import gql from "graphql-tag";

export default gql`
  query ValuationWallForTickerSymbol(
    $tickerSymbol: TickerSymbol!
    $securityCountry: SecurityCountry!
    $verbiageLanguage: ValuationIndicatorVerbiageLanguage!
  ) {
    valuationWallForTickerSymbol(tickerSymbol: $tickerSymbol, country: $securityCountry) {
      category
      verbiage(language: $verbiageLanguage) {
        abbreviation
        formula
        description
      }
      indicator
      asOfDate
      value
      formattedValue
      viewerCanSeeHistory
    }
  }
`;
